import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const TitleSkeleton = (
  <Skeleton
    title={{
      style: {
        height: 20,
        width: '120px',
        margin: '0',
        borderRadius: '4px'
      }
    }}
    paragraph={false}
    active
  />
);

export const CountSkeleton = (
  <Skeleton
    title={{
      style: {
        height: 20,
        width: '20px',
        margin: '0',
        borderRadius: '4px',
        marginLeft: '8px'
      }
    }}
    paragraph={false}
    active
  />
);

export const SportTitleSkeleton = (): ReactElement => {
  return (
    <div className="sportsHeader-titleWrapper--skeleton">
      <div className="sportsHeader-titleInner">
        <span className="sportsHeader-title">{TitleSkeleton}</span>
      </div>
    </div>
  );
};
